import script from "./SimSelectRadio.vue?vue&type=script&setup=true&lang=js"
export * from "./SimSelectRadio.vue?vue&type=script&setup=true&lang=js"

import "./SimSelectRadio.vue?vue&type=style&index=0&id=0e2b343c&lang=scss"

const __exports__ = script;

export default __exports__